import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';

export default function EditPurchase() {
  return (
    <div style={{ maxWidth: 700, margin: '60px auto', padding: '0 20px', textAlign: 'center' }}>
      <h1>Edit Purchase</h1>
      <p>If you purchased a template and want to edit it again, please contact us with your order details.</p>
      <p><Link to="/contact-us">Contact Us <Icon name="arrow_forward" /></Link></p>
    </div>
  );
}
